import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'CreatePassword';

/**
 * Errors related to the Create Password page
 */
export const Errors = createErrors<Page, Component>('CreatePassword')({
    CreatePassword: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to submit create autoship password form',
        },
        HandleRegisterFailed: {
            severity: 'HIGH',
            message: 'Failed to handle register',
        },
        HandleAccessFailed: {
            severity: 'HIGH',
            message: 'Failed to handle access',
        },
    },
});
